
<style lang="less">
  .userManage {

    .formhieght {
      margin-top: 20px;
    }

    .buttonstyle {
      margin-top: -5px;
    }

    .searchbar {
      height: 150px;
      margin-top: -540px;
      width: 100%;
    }

    .searchrow {
      height: 100px;
    }

    .inputwidth {
      width: 230px;
    }

    .width100 {
      width: 80%;
    }

    .width74 {
      width: 74%;
    }

    .width80 {
      width: 77%;
    }

    .width75 {
      width: 76%;
    }

    .width78 {
      width: 78%;
    }

    .width79 {
      width: 79%;
    }

    .width81 {
      width: 81%;
    }

    .el-transfer-panel {
      width: 300px;
    }
  }
</style>
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>



// WEBPACK FOOTER //
// src/App.vue